module.exports = __webpack_public_path__ + "img/1218073674.923cc986.jpg";